// extracted by mini-css-extract-plugin
export default {"LoadingDialog__Content":"LoadingDialog_LoadingDialog__Content__t4Qcg","LoadingDialog__Heading1":"LoadingDialog_LoadingDialog__Heading1__LU+oo"};